import { Link, useSearchParams } from "react-router-dom";
import { useFetch } from "@/hooks/useFetch";
import { useSite } from "@/context/SiteContext";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PublicLayout";
import { CourseCard } from "@/components/site/CourseCard";

export default function Courses() {
  const [params] = useSearchParams();
  const active = params.get("kategori") || "";
  const { categories } = useSite();
  const { data } = useFetch(active ? `/courses?category=${active}` : "/courses");
  const chip = (on) =>
    `rounded-full px-5 py-2.5 text-sm font-bold transition-colors duration-200 ${on ? "bg-navy text-white" : "bg-white border border-navy/20 text-navy hover:bg-bej"}`;
  return (
    <>
      <Seo title="Kurslar" description="Masal Sanat Akademi kursları: müzik ve sanat derslerini kategoriye göre inceleyin, tanışma dersi için randevu alın." />
      <PageHero eyebrow="Kurslar" title="Sana uygun kursu bul">
        Yaş grubu, seviye ve süre bilgileriyle tüm kurslarımız. Karar vermek için bir tanışma dersi yeterli.
      </PageHero>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="flex flex-wrap gap-2 mb-10" data-testid="category-filter">
          <Link to="/kurslar" className={chip(!active)} data-testid="category-filter-all">Tümü</Link>
          {categories.map((c) => (
            <Link key={c.id} to={`/kurslar?kategori=${c.slug}`} className={chip(active === c.slug)} data-testid={`category-filter-${c.slug}`}>
              {c.name}
            </Link>
          ))}
        </div>
        {data && data.length === 0 && <p className="text-slate-600" data-testid="courses-empty">Bu kategoride henüz kurs yok.</p>}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="courses-grid">
          {(data || []).map((c, i) => <CourseCard key={c.id} course={c} index={i} />)}
        </div>
      </section>
    </>
  );
}
